export default "__VITE_ASSET__5309d2ed__"